import { useMutation } from 'react-query';
import { wgApi } from '../../../../app/src/features/api/wgApi';
import { RecalculateYellowhiveQuotesBySessionIdAndProductIdResponse } from 'wg-api-sdk';

interface ProductCalculatePayload {
  coverages: number[];
  due_date?: string;
  payment_interval?: string | null;
}

export const postYellowhiveProductCalculate = async (
  sessionId: string,
  productId: string,
  payload: ProductCalculatePayload,
): Promise<RecalculateYellowhiveQuotesBySessionIdAndProductIdResponse> => {
  const { data, isError } =
    await wgApi.post<RecalculateYellowhiveQuotesBySessionIdAndProductIdResponse>(
      `/v1/api/yellowhiveflows/conversations/${sessionId}/products/${productId}/calculate`,
      payload,
    );
  if (isError) throw new Error(JSON.stringify(data));
  return data;
};

export const useYellowhiveProductCalculate = () => {
  return useMutation<
    RecalculateYellowhiveQuotesBySessionIdAndProductIdResponse,
    unknown,
    { sessionId: string; productId: string; payload: ProductCalculatePayload }
  >(({ sessionId, productId, payload }) =>
    postYellowhiveProductCalculate(sessionId, productId, payload),
  );
};
